/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirming_Perchase_DescriptionInputs */

const en_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're confirming your purchase. Please check back in a few minutes.`)
};

const ar_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نحن نؤكد عملية الشراء. يُرجى التحقق مرة أخرى بعد بضع دقائق.`)
};

const de_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bestätigen deinen Kauf. Bitte sieh in ein paar Minuten erneut nach.`)
};

const es_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos confirmando tu compra. Vuelve a comprobarlo en unos minutos.`)
};

const fr_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous confirmons votre achat. Revenez dans quelques minutes.`)
};

const it_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiamo confermando il tuo acquisto. Controlla di nuovo tra qualche minuto.`)
};

const ja_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入を確認しています。数分後にもう一度ご確認ください。`)
};

const ko_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매를 확인하고 있습니다. 몇 분 후 다시 확인해 주세요.`)
};

const pt_br_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos confirmando sua compra. Confira novamente em alguns minutos.`)
};

const ru_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы подтверждаем вашу покупку. Проверьте снова через несколько минут.`)
};

const th_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรากำลังยืนยันการซื้อของคุณ โปรดกลับมาตรวจสอบอีกครั้งในอีกไม่กี่นาที`)
};

const tr_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın almanı onaylıyoruz. Lütfen birkaç dakika sonra tekrar kontrol et.`)
};

const zh_cn_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们正在确认你的购买，请几分钟后再回来查看。`)
};

const zh_tw_dialog_confirming_perchase_description = /** @type {(inputs: Dialog_Confirming_Perchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們正在確認你的購買，請幾分鐘後再回來查看。`)
};

/**
* | output |
* | --- |
* | "We're confirming your purchase. Please check back in a few minutes." |
*
* @param {Dialog_Confirming_Perchase_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirming_perchase_description = /** @type {((inputs?: Dialog_Confirming_Perchase_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirming_Perchase_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirming_perchase_description(inputs)
	if (locale === "ar") return ar_dialog_confirming_perchase_description(inputs)
	if (locale === "de") return de_dialog_confirming_perchase_description(inputs)
	if (locale === "es") return es_dialog_confirming_perchase_description(inputs)
	if (locale === "fr") return fr_dialog_confirming_perchase_description(inputs)
	if (locale === "it") return it_dialog_confirming_perchase_description(inputs)
	if (locale === "ja") return ja_dialog_confirming_perchase_description(inputs)
	if (locale === "ko") return ko_dialog_confirming_perchase_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirming_perchase_description(inputs)
	if (locale === "ru") return ru_dialog_confirming_perchase_description(inputs)
	if (locale === "th") return th_dialog_confirming_perchase_description(inputs)
	if (locale === "tr") return tr_dialog_confirming_perchase_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirming_perchase_description(inputs)
	return zh_tw_dialog_confirming_perchase_description(inputs)
});